export default defineAppConfig({
  // Default settings for the password
  passwordCriteria: {
    minLength: 8,
    minUppercase: 1,
    minSpecialCharacters: 1,
    minNumbers: 1,
  },

  // Default settings for file uploads
  acceptedImageTypes: [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/avif',
    'image/webp',
  ],
  maxImageFileSize: 5, // In MB
  acceptedFileTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/csv',
  ],
  maxFileSize: 10, // In MB

  // Default locale for the application
  currency: {
    label: 'AUD',
    locale: 'en-AU',
    symbol: '$',
  },

  // Default date format for the application
  dateFormat: 'DD/MM/YYYY',

  // Default pagination settings
  defaultPerPage: 10,

  // Default toast/snackbar settings
  toast: {
    life: 3000,
  },

  // Authentication settings
  auth: {
    verificationCode: {
      intervalSeconds: 60,
      cookieMaxAge: 120,
    },
  },
});
